import { Route, Routes } from "react-router-dom";
import { SiteLayout } from "./components/SiteLayout";
import { DoramaPage } from "./pages/DoramaPage";
import { GuideArticlePage } from "./pages/GuideArticlePage";
import { GuidesPage } from "./pages/GuidesPage";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { AboutPage } from "./pages/AboutPage";
import { MyPurchasesPage } from "./pages/MyPurchasesPage";
import { LegalPage } from "./pages/LegalPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { VipPage } from "./pages/VipPage";
import { AdminPage } from "./pages/AdminPage";
import { PaymentPage } from "./pages/PaymentPage";

export function App() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/dorama/:slug" element={<DoramaPage />} />
        <Route path="/minhas-compras" element={<MyPurchasesPage />} />
        <Route path="/pagamento" element={<PaymentPage />} />
        <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
        <Route path="/termos" element={<LegalPage type="terms" />} />
        <Route path="/privacidade" element={<LegalPage type="privacy" />} />
        <Route path="/sobre" element={<AboutPage />} />
        <Route path="/guias" element={<GuidesPage />} />
        <Route path="/guias/:slug" element={<GuideArticlePage />} />
        <Route path="/vip" element={<VipPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
